import { motion } from "framer-motion";
import { Zap, Award, Layers, Headphones, Shield } from "react-feather";
import AnimatedCounter from "./AnimatedCounter";

const reasons = [
  { icon: Zap, title: "Fast Development", desc: "Agile delivery without compromising quality" },
  { icon: Award, title: "Premium Quality", desc: "Enterprise-grade code and design standards" },
  { icon: Layers, title: "Scalable Architecture", desc: "Built to grow with your business" },
  { icon: Headphones, title: "24/7 Support", desc: "Dedicated assistance when you need it" },
  { icon: Shield, title: "Secure Systems", desc: "Industry best practices for data protection" },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 md:py-32 bg-navy relative overflow-hidden">
      <div className="absolute inset-0 bg-hero-mesh" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-gold font-semibold text-sm uppercase tracking-widest">Why Choose Us</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-white">Trusted by Innovators</h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-16">
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md text-center hover:border-gold/30 transition-all"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-gold/20 flex items-center justify-center text-gold mb-4">
                <r.icon size={22} />
              </div>
              <h3 className="text-white font-bold">{r.title}</h3>
              <p className="mt-2 text-white/60 text-sm">{r.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 p-8 rounded-3xl bg-white/5 border border-white/10">
          <AnimatedCounter end={50} suffix="+" label="Projects Delivered" />
          <AnimatedCounter end={100} suffix="%" label="Client Satisfaction" />
          <AnimatedCounter end={10} suffix="+" label="Technologies" />
          <AnimatedCounter end={5} suffix="+" label="Years Expertise" />
        </div>
      </div>
    </section>
  );
}
